<div #saleItemDetails class="details">
  <div class="details-container">
    <div style="margin-bottom: 2rem">
      <scale-button
        icon-position="start"
        (click)="goBack.emit()"
        size="small"
        variant="secondary-white">
        <scale-icon-navigation-left></scale-icon-navigation-left>
        {{ 'rem.properties.label__back' | translate }}
      </scale-button>
    </div>

    <div class="file-previews" *ngIf="isDesktopView">
      <div
        class="file-preview"
        *ngFor="let item of items; let i = index"
        [lightbox]="i"
        [gallery]="galleryId"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Bild vergrößern: ' + (i + 1)"
        (keydown.enter)="openLightbox(i)"
        (keydown.space)="openLightbox(i); $event.preventDefault()">
        <img
          class="sale-details-image"
          [src]="item.data.thumb"
          onerror="
            this.onerror = null;
            this.src = '../../../assets/icons/scan_delete.svg';
          " />
      </div>
    </div>

    <div class="file-preview-mobile" *ngIf="!isDesktopView">
      <gallery
        #gallery
        [counter]="false"
        [dots]="true"
        [thumb]="false"
        [imageSize]="'cover'"
        [items]="items"></gallery>
    </div>

    <h2>
      {{ location.title }}
    </h2>

    <h3 style="display: flex; gap: 1.25rem; font-style: italic">
      <span *ngIf="location.specificPrice; else noPrice">
        {{ location.specificPrice }}
      </span>
      <ng-template #noPrice>
        <span>{{ 'rem.properties.label__price_on_request' | translate }}</span>
      </ng-template>
      <span *ngIf="location.areaSpecification">
        {{ location.areaSpecification }}
      </span>
    </h3>
    <hr class="thin" *ngIf="location?.description" />

    <p *ngIf="location?.description">{{ location.description }}</p>

    <hr class="thin" *ngIf="pdfList.length > 0 || location?.links.length > 0" />
    <div style="margin-top: 3.75rem; margin-bottom: 1.25rem; font-weight: bold">
      <p *ngIf="pdfList.length > 0 || location?.links.length > 0">
        <span
          *ngIf="
            location?.additionalInformation;
            else additionalInformationDefault
          ">
          {{ location.additionalInformation }}
        </span>
        <ng-template #additionalInformationDefault>
          <span>
            {{ 'website_edit.sale.further_information_default' | translate }}
          </span>
        </ng-template>
      </p>
    </div>

    <div
      class="link-container"
      *ngIf="pdfList.length > 0 || location?.links.length > 0">
      <a
        *ngFor="let pdf of pdfList"
        [href]="pdf.uri"
        style="color: white; display: flex; gap: 0.625rem; font-size: large"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="pdf.displayName + ' (öffnet in neuem Tab)'"
        class="custom-immoscout-button">
        <img
          src="assets/icons/Link.png"
          alt="Datei"
          style="width: 1.25rem; height: 1.25rem" />
        <span style="text-decoration: underline">
          {{ pdf.displayName }}
        </span>
      </a>
      <a
        *ngFor="let link of location.links"
        [href]="link.link"
        style="color: white; display: flex; gap: 0.625rem; font-size: large"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="link.linkDisplayName + ' (öffnet in neuem Tab)'"
        class="custom-immoscout-button">
        <img
          src="assets/icons/Link.png"
          alt="Datei"
          style="width: 1.25rem; height: 1.25rem" />
        <span style="text-decoration: underline">
          {{ link.linkDisplayName }}
        </span>
      </a>
    </div>

    <div *ngIf="location.hideSubmitOffer !== true">
      <p style="margin-top: 3.75rem; margin-bottom: 1.25rem; font-weight: bold">
        Interesse geweckt? Unterbreiten Sie jetzt ein unverbindliches Angebot.
      </p>

      <div class="link-container">
        <button
          type="button"
          style="color: white; display: flex; gap: 0.625rem; font-size: large"
          (click)="routeToContactForm()"
          class="custom-immoscout-button"
          aria-label="Angebot unterbreiten">
          <img
            src="assets/icons/Angebot.png"
            alt="Datei"
            style="width: 1.25rem; height: 1.25rem" />
          <span> Angebot unterbreiten </span>
        </button>
      </div>
    </div>

    <div
      [style.margin-top]="
        pdfList.length === 0 && location?.links.length === 0
          ? location.hideSubmitOffer === true
            ? '13.125rem'
            : '4.375rem'
          : location.hideSubmitOffer === true
            ? '4.375rem'
            : '0'
      ">
      <img
        src="assets/images/Verkauf.png"
        alt="Gebäude Verkauf"
        class="info-img" />
    </div>
  </div>
</div>
